(function() {
    'use strict';

    angular.module('app').directive('fodbzHelpedLabel', FodbzHelpedLabelDirective);
    function FodbzHelpedLabelDirective() {
        return {
            transclude: true,
            scope: {
                fodbzField: '@',
                fodbzResource: '@',
                fodbzInfo: '@',
            },
            template: `<fodbz-label fodbz-field="{{fodbzField}}" fodbz-resource="{{fodbzResource}}">
                &nbsp;
                <fodbz-info-sign fodbz-info="{{fodbzInfo}}"></fodbz-info-sign>
            </fodbz-label>`
        };
    }
})();